import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/gpa-calculator',
  component: () => import('../../routes/GpaCalculator.svelte'),
  card: {
    id: 'gpa-calculator',
    title: 'GPA Calculator',
    description: 'Calculate your Grade Point Average (GPA) weighted by credit hours. Supports 4.0, 4.33, and 5.0 scales.',
    icon: 'school',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/gpa-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'GPA Calculator — Weighted Grade Point Average',
    description: 'Free GPA calculator that calculates your weighted GPA based on course credits and grades. Supports 4.0, 4.33, and 5.0 grading scales with semester and cumulative GPA.',
  },
};

export default meta;
